// PageProjectViewTask Component
/* eslint react/jsx-indent: 0, indent: 0 */

import React from 'react'
import _ from 'lodash'

import app from '../../../app.jsx'
import BaseProjectView from '../../page/base_projectview/base_projectview.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import ProfilerUtil from '../../../lib/profilerutil.jsx'
import PlannerPageProvider from '../../../lib/planner_pageprovider.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../../theme/common/icon_button/icon_button.jsx'
import Grid from '../../../theme/grid/grid/grid.jsx'
import PlannerActionGroup from '../../../theme/planner/planner_actiongroup/planner_actiongroup.jsx'
import FieldTitle from '../../../theme/form/field_title/field_title.jsx'
import DroppableContainer from '../../../theme/common/droppable_container/droppable_container.jsx'
import DragLayer from '../../../theme/common/draglayer/draglayer.jsx'
import PlannerTaskQuickAdd from '../../../theme/planner/planner_taskquickadd/planner_taskquickadd.jsx'

class PageProjectViewTask extends BaseProjectView {
  constructor (props) {
    super(props, 'projectview-task', 'project', 'projectview-task')

    this.data = {
      projectId: this.props.projectId,
      project: this._getProjectFromCache(this.props.projectId),
      stat: this._getOverviewStatFromCache(this.props.projectId),
      histories: [],
      sort: 'title',
      sortAsc: true,
      filter: null,
      tasks: [],
      projects: [],
      activities: [],
      skillOptions: [],
      currentEditObject: null,
      activeTask: null,
      pageState: {
        filters: [],
        filter: {
          contactIds: [],
          projectIds: [],
          userIds: [],
          fromDate: null,
          toDate: null
        },
        visibleObjects: ['activity', 'task'],
        expandObjectIds: []
      },
      showProjectInfo: false,
      users: []
    }

    this.state = {
      profilerId: null
    }

    this._references = {
      sidebarTask: React.createRef(),
      dialogTimeCardDetail: React.createRef(),
      droppablePagebreakTop: React.createRef(),
      uploadErrorDialog: React.createRef()
    }
    this.createCommonReference(this._references)

    /* Initialize profiler */
    this._profiler = new ProfilerUtil(this._pageIdent, 3) // Average time 3 seconds
    this._profiler.start()
    this._profiler.setParams(this.props.projectId)

    this._bUnMounted = false
  }

  componentDidMount () {
    app.updatePageTitle('project-view', 'Tasks')
    this._initEvents()

    this._getData(false)

    // Calculate and save profiler, Hardcode profiler id as 1, since it is the first call of profiler
    this._profiler.stop(1)
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
    this._profiler = null
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._profiler &&
      (!prevState || prevState.profilerId !== this.state.profilerId) &&
      this.state.profilerId
    ) {
      this._profiler.stop(this.state.profilerId)
    }
  }

  _initializeUserFilters () {
    const { pageState, project } = this.data

    if (project && project.contact) {
      const filters = pageState.filters || []
      const contactId = project.contact.id
      const projectId = project.id

      // Add current project and contact as default filter
      filters.unshift(
        this.getProjectFilterObject(projectId, project.title),
        this.getContactFilterObject(contactId, project.contact.company)
      )

      pageState.filters = filters
      pageState.filter.contactIds = [contactId]
      pageState.filter.projectIds = [projectId]
    }
  }

  getProjectFilterObject (projectId, title) {
    return {
      ident: 'project',
      typeLabel: IntlUtil.convertMessage('common.newfilter.lableIdentProject'),
      value: projectId,
      text: title,
      hideDelete: true
    }
  }

  getContactFilterObject (contactId, title) {
    return {
      ident: 'contact',
      typeLabel: IntlUtil.convertMessage('common.newfilter.lableIdentContact'),
      value: contactId,
      text: title,
      hideDelete: true
    }
  }

  getContentClassname () {
    return 'alt'
  }

  /* Render functions */
  render () {
    return this.renderDetailPageContent()
  }

  renderContent () {
    const { tasks, pageState, activities } = this.data
    const unSortedTasks = []
    const showActivity =
      (pageState.visibleObjects &&
        pageState.visibleObjects.indexOf('activity')) >= 0

    tasks.map(task => {
      if (!task.activityId) {
        unSortedTasks.push(task)
      }
    })

    const canDragTask = showActivity && activities.length > 1

    return (
      <div className='pagecontentwrap'>
        {this._renderGridFilter()}
        {this._renderTaskActionGroup()}
        <Grid>
          {this._renderTaskGridHeader(canDragTask)}
          <div className='cgrid-content tasklist'>
            {showActivity
              ? activities.map((activity, idx) => (
                  <React.Fragment key={idx}>
                    {this._renderActivityItem(activity, canDragTask)}
                    {this._renderQuickAdd(activity)}
                  </React.Fragment>
                ))
              : tasks.map(task => this._renderTaskItem(task))}
            <DragLayer />
          </div>
          {showActivity && unSortedTasks && unSortedTasks.length > 0 && (
            <div className='unsortedtaskcontent'>
              <FieldTitle title='plannerv2.task.unSortedTaskTitle' />
              {unSortedTasks.map(unSortedTask =>
                this._renderTaskItem(unSortedTask, canDragTask)
              )}
            </div>
          )}
        </Grid>
        {this._renderTimecardDetail()}
        {this._renderDialogConfirm()}
      </div>
    )
  }

  renderRightSidebar () {
    const { projects, skillOptions } = this.data
    return this._renderRightSidebarTask(projects, skillOptions)
  }

  _renderQuickAdd = activity => {
    const { project, users, pageState } = this.data
    const showTask =
      pageState.visibleObjects &&
      pageState.visibleObjects.indexOf('task') !== -1

    if (showTask) {
      return (
        <PlannerTaskQuickAdd
          activityId={activity.id}
          projectId={project.id}
          users={users}
          onSave={this._onSaveQuickAddTask} // eslint-disable-line react/jsx-handler-names
        />
      )
    }

    return null
  }

  _onSaveQuickAddTask = (createData, callback) => {
    createData.createdById = app.loggedInId
    createData.active = true

    app
      .service('/api/project/plannertask')
      .create(createData)
      .then(_createRes => {
        this._reloadData()
        if (callback) {
          callback()
        }
      })
      .catch(err => {
        app.debug('BasePlannerPage::_onCreateTask - Error ', err)
        if (callback) {
          callback()
        }
      })
  }

  /* Private function */
  _getSaveObjectPageState (pageState) {
    const { project } = this.data
    const savePageStateData = _.cloneDeep(pageState)

    _.remove(savePageStateData.filters, filter => filter.hideDelete)

    if (savePageStateData.filter) {
      if (savePageStateData.filter.contactIds && project.contact) {
        _.remove(
          savePageStateData.filter.contactIds,
          contactId => contactId === project.contact.id
        )
      }

      if (savePageStateData.filter.projectIds && project) {
        _.remove(
          savePageStateData.filter.projectIds,
          projectId => projectId === project.id
        )
      }
    }

    return savePageStateData
  }

  _getData (_bReload) {
    const { projectId } = this.data
    const params = {
      query: {
        teamId: app.getTeamId(),
        projectId: this.props.projectId,
        pageIdent: this._pageIdent,
        project: {
          $client: {
            subObjects: {
              contact: ['company', 'rateCards', 'rateMarkup', 'rate']
            }
          }
        },
        task: {
          pageIdent: this._pageIdent,
          $client: {
            initialProject: {
              projectId,
              labelProject: IntlUtil.convertMessage(
                'common.newfilter.lableIdentProject'
              ),
              labelContact: IntlUtil.convertMessage(
                'common.newfilter.lableIdentContact'
              )
            },
            getUser: true
          }
        }
      }
    }

    return app
      .service('/api/page/project/task')
      .find(params)
      .then(taskRes => {
        this._onPageDataRecieved(taskRes.pageData)
        this.data.tasks = taskRes.tasks || []
        this.data.histories = taskRes.histories || []
        this.data.project = taskRes.project || null
        this.data.pageState = taskRes.pageState
        const expandObjectIds = this.data.pageState.expandObjectIds || []

        if (taskRes.projectOptions) {
          this.data.projects = taskRes.projectOptions || []
        }

        if (taskRes.skillOptions) {
          this.data.skillOptions = taskRes.skillOptions || []
        }

        if (taskRes.activities) {
          this.data.activities = taskRes.activities || []
          this.data.activities.forEach(activity => {
            expandObjectIds.push(activity.id)
          })
        }

        if (this.data.tasks) {
          this.data.tasks.forEach(task => {
            const activity = this.data.activities.find(
              activity => activity.id === task.activityId
            )
            activity && (task.activityIsActive = !!activity.isActive)

            expandObjectIds.push(task.id)
          })
        }

        this.data.pageState.expandObjectIds = expandObjectIds

        return this._getTaskUsers(this.data.project.id)
      })
      .then(users => {
        this.data.users = users
        this._onDataReceived(null)
        this._setProjectToCache(this.data.project)
        app.updatePageTitle(
          'projectview-planner',
          this.data.project ? this.data.project.title : ''
        )
      })
      .catch(err => {
        this._onDataReceived(err)
      })
  }

  _getTaskUsers = projectId => {
    const fromDate = new Date()
    const toDate = new Date(fromDate)
    toDate.setDate(toDate.getDate() + 30)

    const params = {
      query: {
        keywords: [],
        mode: 'all',
        fromDate: fromDate,
        toDate: toDate,
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset()
      }
    }

    if (projectId) {
      params.query.projectId = projectId
    }

    return app
      .service('/api/project/plannersearch')
      .find(params)
      .then(searchRes => {
        const userOptions = []

        // Filter out inactive users
        const users = searchRes.data.filter(user => user.status === 'active')

        users.forEach(user => {
          userOptions.push({
            label: user.displayName,
            value: user.id,
            imageUrl: user.imageUrl
          })
        })

        return Promise.resolve(userOptions)
      })
      .catch(err => {
        app.debug('PageProjectViewTask: _getTaskUsers Error', err)
        return Promise.resolve([])
      })
  }

  _reloadData () {
    this._getData(true)
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageTask: _onDataReceived Error', err)
      this.setState({ dataDate: new Date() })
    } else {
      app.debug('PageTask: _onDataReceived [done]')
      this.setState({ dataDate: new Date() })
    }
  }

  _renderActivityItem (activity, canDrag) {
    const { tasks, pageState } = this.data
    const activityTasks = tasks.filter(task => task.activityId === activity.id)
    const showExpand =
      activityTasks.length > 0 &&
      pageState.visibleObjects &&
      pageState.visibleObjects.indexOf('task') >= 0

    const { expandObjectIds } = pageState
    const bExpand = !!(
      showExpand &&
      expandObjectIds &&
      expandObjectIds.indexOf(activity.id) >= 0
    )

    return (
      <DroppableContainer
        active
        key={activity.id}
        onDropItem={this._onDropItem.bind(this, activity.id)}
      >
        <div key={activity.id} className='activityitem'>
          <div className={`content ${bExpand ? 'expanded' : ''}`}>
            {this._renderActivityObject(activity, showExpand, bExpand)}
          </div>
          {bExpand && (
            <div className='subcontent'>
              {activityTasks.map(task => this._renderTaskItem(task, canDrag))}
            </div>
          )}
        </div>
      </DroppableContainer>
    )
  }

  _renderActivityObject (activity, showExpand, bExpand) {
    const { project, tasks } = this.data
    let phaseName = ''
    let dragEnable = false

    if (
      project &&
      project.budget.phases.length === 1 &&
      project.budget.noActiveTimeActivities === 1
    ) {
      dragEnable = true
    }

    project.budget.phases.map((phase, idx) => {
      if (activity.phaseNo - 1 === idx) {
        phaseName = phase.title
      }
    })

    const currentTask = tasks.filter(task => task.id === activity.id)
    const budgetedHours = activity.noHours || 0
    let totalTaskDuration = 0
    tasks.forEach(task => {
      if (activity.id === task.activityId) {
        totalTaskDuration += task.duration
      }
    })
    totalTaskDuration = Math.round(totalTaskDuration / 60)
    const completeView = bExpand

    return (
      <div className='planner-activity'>
        <div className='titleinfo' style={{ width: completeView ? 50 : 98 }}>
          <div className='actioncont'>
            {showExpand && (
              <IconButton
                icon={bExpand ? 'arrow-up' : 'arrow-down'}
                iconSize='12'
                className='actionexpand'
                canHover
                onClick={this._onToggleExpandActivity.bind(
                  this,
                  activity.id,
                  !bExpand
                )}
              />
            )}
          </div>
        </div>

          <div className='task-title'>{`${phaseName} - ${activity.title}`}</div>

          <div
            className='task-description'
            dangerouslySetInnerHTML={{ __html: currentTask?.description }}
          />

          <div className='task-project-name'>
            {currentTask?.project?.title}
          </div>

          <div className='task-client-name'>
            {currentTask?.project?.contact?.company}
          </div>

          <div
            className='task-due-date'
          >
            {activity.toDate
                  ? DateUtil.getDisplayDate(activity.toDate)
                  : ''}
          </div>

          <div className='task-assignee'>
            <div className='data' />
          </div>

          <div className='task-project-hour'>
            <span className='data'>
              {totalTaskDuration}
            </span>
          </div>

          <div className='task-budget-hour'>
            {budgetedHours}
          </div>

          <div className='task-time' />

          <div className='task-priority' />

        <div className={`actioninfo${dragEnable ? ' phaseactioninfo' : ''}`}>
          {!this._showRightSidebar && (
            <IconButton
              icon='+'
              className='detailadd'
              type='secondary'
              canHover
              onClick={this._onAddTask.bind(this, activity.id)}
            />
          )}
        </div>
      </div>
    )
  }

  _onDropItem (activityId, taskInfo) {
    if (!taskInfo.id) {
      return
    }

    this._onUpdateTaskInfo(taskInfo.id, { activityId })
  }

  _onToggleExpandActivity (objectId, bExpand) {
    let { expandObjectIds } = this.data.pageState
    if (!expandObjectIds) {
      expandObjectIds = []
    }

    if (bExpand) {
      expandObjectIds.push(objectId)
    } else {
      _.remove(expandObjectIds, id => id === objectId)
    }

    this.data.pageState.expandObjectIds = expandObjectIds
    this.setState({ bExpand: false, dataDate: new Date() })
  }

  _renderTaskActionGroup () {
    const { pageState } = this.data
    return (
      <div className='gridactionbar'>
        <PlannerActionGroup
          title='plannerv2.task.plannerActionTitle'
          actions={[
            {
              ident: 'activity',
              title: 'plannerv2.task.plannerActionActivity'
            },
            {
              ident: 'task',
              title: 'plannerv2.task.plannerActionTask'
            }
          ]}
          activeActions={pageState.visibleObjects}
          onChange={this._onChangeVisibleObjects.bind(this)}
        />
      </div>
    )
  }

  /* Realtime Events */
  _initEvents () {
    this._initTaskEvents()
    this._initTimerEvents(this._onReloadTimer.bind(this))
  }

  _releaseEvents () {
    this._releaseTaskEvents()
    this._releaseTimerEvents()
  }

  _eventReloadTask (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageTask - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  _onReloadTimer (eventData) {
    if (eventfilters.teamFilter(eventData)) {
      this._reloadData()

      if (this.data.activeTask) {
        this._createOrUpdateTask(this.data.activeTask)
        this.data.activeTask = null
      }
    }
  }
}

export default PlannerPageProvider(PageProjectViewTask)
